import { selectAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  field: {
    background: "white",
    border: "1px solid",
    borderColor: "gray.50",
    fontSize: "12px",
    borderRadius: "7px",
    height: "35px",
    // padding: "14px",
    fontWeight: "500",
  },
  icon: {
    color: "secondary",
    fontSize: "24px",
    marginLeft: "16px",
  },
});

const md = defineStyle({
  fontSize: "16px",
  px: "15",
  h: "42px",
  borderWidth: "1.5px",
  fontWeight: "400",
});

/*
const md = defineStyle({
  fontSize: "12px",
  px: "4",
  h: "35px",
});
*/

// const primary = definePartsStyle({
//   field: {
//     background: "white",
//     border: "1px dashed",
//     borderColor: "gray.50",
//     borderRadius: "7px",
//     color: "purple",
//   },
//   icon: {
//     color: "secondary",
//   },
// });

export const selectTheme = defineMultiStyleConfig({
  baseStyle,
  //   variants: {
  //     primary,
  //   },
  sizes: {
    md: definePartsStyle({ field: md }),
    sm: baseStyle,
  },
  defaultProps: {
    variant: "lendtech",
    // size: "lendtech",
  },
  variants: {
    scenario: {
      field: {
        padding: "0px 34px 0px 15px",
        borderRadius: "5px",
        background: "#F9F8F8",
        fontSize: "14px",
        textAlign: "right",
        height: "30px",
        color: "secondary",
        borderWidth: "0px",
        _disabled: {
          color: "gray.200",
          opacity: 1,
        },
      },
    },
    lendtech: {},
  },
});
